import { useState } from "react";
import { v4 } from "uuid";
import { FormatFileSize } from "../../../../utils/FormatFileSize";

export interface IFileCustom extends File {
  sizeFormatted: string;
  uuid: string;
  file: File;
}

export const useInputFile = () => {
  const [file, setFile] = useState<IFileCustom | null>(null);

  const dropHandler = (inputFile: File) => {
    if (inputFile) {
      const formattedSize = FormatFileSize(inputFile.size, 2);
      const fileId = v4();

      const newFile: IFileCustom = {
        ...inputFile,
        file: inputFile,
        sizeFormatted: formattedSize,
        uuid: fileId,
      };

      setFile(newFile);
    }
  };

  return {
    dropHandler,
    file,
  };
};
